export function createPage(page = {}) {
  const { id, pageType = '' } = page;

  return { id, pageType };
}
